import React from 'react';
import './EmptyHighlights.scss';
import triangle from '../../assets/imgs/triangle-copy.svg'

const fillers = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];

const EmptyHighlights = ()=> {
  return (
    <div className='empty-highlights'>
      {fillers.map(filler =>
      <div key={filler} className='empty-highlights__filler' >
        <img src={triangle} alt=''/>
      </div>
    )}
      <div className='empty-highlights__title'>
        <span>THERE ARE NO HIGHLIGHTS</span>
        <span>START RECORDING</span>
      </div>
    </div>
  );
};

export default EmptyHighlights;
